import { useCallback, useState } from 'react'

import type { QuerySsoUrlArgs, SsoUrl } from '@tribeplatform/gql-client/types'

import type { UseQueryOptions } from '../../lib/react-query/useQuery.js'
import { useQueryClient } from '../../lib/react-query/useQueryClient.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getLoginWithSsoKey } from '../../utils/keys/authToken.keys.js'

export const useLoginWithSso = (options?: {
  useQueryOptions?: UseQueryOptions<SsoUrl>
}) => {
  const { useQueryOptions } = options || {}
  const queryClient = useQueryClient()
  const { client } = useTribeClient()
  const [isLoading, setLoading] = useState(false)

  const login = useCallback(
    async (variables: QuerySsoUrlArgs) => {
      const loginWithSsoKey = getLoginWithSsoKey({ variables })
      setLoading(true)
      const data = await queryClient.fetchQuery(
        loginWithSsoKey,
        () => client?.auth.ssoUrl(variables),
        useQueryOptions,
      )
      setLoading(false)
      return data
    },
    [client?.auth, queryClient, useQueryOptions],
  )

  return {
    login,
    isLoading,
  }
}
